import ApiController, { ApiRequest } from "../controller";

class PassModule extends ApiController {
  resource = "/pass";

  passes() {
    const request = new ApiRequest({
      method: "GET",
      url: `/passes`
    });

    return this.request<any>(request);
  }

  giftable() {
    const request = new ApiRequest({
      method: "GET",
      url: `/giftable`
    });

    return this.request<any>(request);
  }

  pass(id) {
    const data = {
      id
    }

    const request = new ApiRequest({
      method: "POST",
      url: `/pass`,
      body: data
    });

    return this.request<any>(request);
  }

  customerPass(id, signature) {
    const data = {
      id,
      signature
    }

    const request = new ApiRequest({
      method: "POST",
      url: `/customerPass`,
      body: data
    });

    return this.request<any>(request);
  }

  claim(id, signature, customer, claim) {
    const requestCustomer: any = {}

    if (customer.id) {
      requestCustomer.id = customer.id
    } else {
      requestCustomer.attributes = customer.fields
      requestCustomer.customFields = customer.customFields
      requestCustomer.acceptConsent = customer.privacyConsentAccepted
      requestCustomer.acceptMarketingConsent = customer.marketingConsentAccepted
    }

    const data = {
      id,
      signature,
      customer: requestCustomer,
      claim
    }

    const request = new ApiRequest({
      method: "POST",
      url: `/claim`,
      body: data
    });

    return this.request<any>(request);
  }

  purchase(action, customer, pass, termsAccepted, giftCards, giftCardCode, paymentData, paymentParams, { to, from, message, deliveryDate }) {
    const requestCustomer: any = {}

    if (customer.id) {
      requestCustomer.id = customer.id
    } else {
      requestCustomer.attributes = customer.fields
      requestCustomer.customFields = customer.customFields
      requestCustomer.acceptConsent = customer.privacyConsentAccepted
      requestCustomer.acceptMarketingConsent = customer.marketingConsentAccepted
    }

    const data: any = {
      action,
      customer: requestCustomer,
      pass: { id: pass.id },
      termsAccepted,
      payment: {}
    }

    if (to || from || message || deliveryDate) {
      const gift: any = {}
      if (to) {
        gift.to = { name: to.name, email: to.email }
      }
      if (from) {
        gift.from = { name: from.name }
      }
      if (message) gift.message = message
      if (deliveryDate) gift.deliveryDate = deliveryDate

      data.gift = gift
    }

    if (paymentData) {
      data.payment.data = paymentData
    }

    if (paymentParams) {
      data.payment.params = paymentParams
    }

    if (giftCardCode) {
      data.giftCardRequest = giftCardCode
    }

    if (giftCards) {
      data.payment.giftCards = giftCards.map((giftCard) => {
        return giftCard.number
      })
    }

    const request = new ApiRequest({
      method: "POST",
      url: `/purchase`,
      body: data
    });

    return this.request<any>(request);
  }
}

export default PassModule;